import template from './description-chantier.html'
import css from './description-chantier.css'
import { DescriptionChantierController } from './description-chantier.controller.js'

export const DescriptionChantierComponent = {
  template: template,
  controller: DescriptionChantierController,
  controllerAs: 'DescriptionChantierController',
  require: {
	parentSimulator: '^^simulatorComponent'
  },

  bindings: {
    resource: '='
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/description-chantier/description-chantier.component.js